import React from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem, Button } from '@mui/material';
import { CustomRecurrenceRule } from '../CustomRecurrenceModal';
import { RECURRENCE_OPTIONS } from '@features/appointments';

interface RecurrencePickerProps {
  recurrence: string;
  customRecurrenceRule: CustomRecurrenceRule | null;
  text?: string;
  onRecurrenceChange: (value: string) => void;
  onCustomRecurrenceClick: () => void;
  title?: string;
}

export const RecurrencePicker: React.FC<RecurrencePickerProps> = ({
  recurrence,
  customRecurrenceRule,
  onRecurrenceChange,
  onCustomRecurrenceClick,
  text,
}) => {
  return (
    <Box>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel id="recurrence-select-label">Recurrence</InputLabel>
        <Select
          labelId="recurrence-select-label"
          id="recurrence-select"
          value={recurrence}
          label="Recurrence"
          onChange={e => onRecurrenceChange(e.target.value)}
          size="small"
        >
          {RECURRENCE_OPTIONS.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Show a summary of custom recurrence if selected */}
      {recurrence === 'custom' && customRecurrenceRule && text && (
        <Button variant="outlined" onClick={onCustomRecurrenceClick} size="medium" fullWidth>
          Repeats {text}
        </Button>
      )}
    </Box>
  );
};

export default RecurrencePicker;
